import { render } from "./NaechsteSchritteView.vue?vue&type=template&id=2a2b2a9c&lang=true"
import script from "./NaechsteSchritteView.vue?vue&type=script&lang=js"
export * from "./NaechsteSchritteView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__